import z from "zod";
import { OC } from "../../utils";
import { ClientAuth } from "./schema";

export const authContract = OC.router({
  signIn: OC.input(ClientAuth.SignIn).output(
    ClientAuth.AuthData.shape.user.extend({ token: z.string() }),
  ),
  signOut: OC,
  getAuth: OC.output(ClientAuth.AuthData.omit({ session: true }).nullable()),
  updateProfile: OC.input(ClientAuth.UpdateProfile).output(
    ClientAuth.AuthData.shape.user,
  ),
  updateProfileImage: OC.$route({ method: "POST" })
    .input(ClientAuth.UpdateProfileImage)
    .output(ClientAuth.AuthData.shape.user),
  // National ID (E2E encrypted)
  getNId: OC.output(ClientAuth.getNId),
  updateNId: OC.$route({ method: "POST" }).input(ClientAuth.UpdateNId),
  deleteNId: OC,
  getAgenciesForNIdSharing: OC.output(ClientAuth.GetAgenciesForNIdSharing),
});
